import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { AccountService } from '../account.service';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { Message } from 'primeng/primeng';


export interface Pagination {
  current_page?: number;
  first_item?: number;
  first_page_url?: string;
  last_item?: number;
  last_page?: number;
  last_page_url?: string;
  next_page_url?: string;
  per_page?: number;
  prev_page_url?: string;
  total?: number;
}

@Component({
  selector: 'app-account',
  templateUrl: './account.component.html',
  styleUrls: ['./account.component.css'],
  providers: [AccountService],
  encapsulation: ViewEncapsulation.None
})
export class AccountComponent implements OnInit {

  
  cashboxTransaction: any =[];
  cashboxTransactionModal : boolean = false;
  closeCashboxModal : boolean = false;
  loadingTransactionTable: boolean = true;	
  loading:boolean = false;
  loadingBonus:boolean = false;
  accounts  : any = [];
  bonuses  : any = [];
  pagination: Pagination;
  id: any= null;
  accountId: any = null;
  msgs: Message[] = [];
  
  messageDisplay:boolean = false;

  constructor(  
              private router: Router,
              private location: Location,
              private activatedRoute: ActivatedRoute,
              private accountService: AccountService
             ) { 
         activatedRoute.params.subscribe(params=>{this.id=params['id']});
  }
 
  ngOnInit() {
      this.onLoad();

      this.pagination = {
        current_page: 1,
        per_page: 1
      }
  }

  // onPaginate(event) {
  //   this.pagination.current_page=event.page + 1;
  //   this.getAccountTransaction(this.accountId,this.pagination.current_page);
  // }

  // getAccountTransaction(id:any,page:number){
  //   this.loadingTransaction=true;
  //   this.accountService.getAccountTransaction(id,page).subscribe(response=>{
  //   this.pagination = response['pagination'] || this.pagination;
  //   this.accountTransactions = response['data'];
  //   this.loadingTransaction=false;
  // });
  // }


  // showTransactionModal(id: any){
  //   this.accountId=id;
  //   this.cashboxTransactionModal = true;
  //   this.loadingTransaction=true;
  //   this.getAccountTransaction(this.accountId,this.pagination.current_page);
  // }

  showTransactionPage(id: any,contractor_id: any){
    this.router.navigate(['dashboard/account-crud/',{id: id,contractor_id: contractor_id}]);
  }


  onLoad(){
    this.loading  = true;
    this.loadingBonus  = true;
    this.accountService.getAccountById(this.id).subscribe(response=>{this.accounts = response['data'];this.loading  = false});
    this.accountService.getBonusByFilter([{name: 'contractor_id',value: this.id}]).subscribe(response=>{this.bonuses=response['data'];this.loadingBonus  = false;})
  }

  OnAgree() {
    this.onCalculate();
    this.messageDisplay = false;
  }

  OnDegree() {
    this.messageDisplay = false;
  }
  onCalculate(){
    this.accountService.claculateBonus(this.id).subscribe(response=>{
      this.msgs=[]; 
      this.msgs.push({ severity: 'success', summary: 'Сообщение', detail: "Бонус успешно рассчитан!" });
      this.onLoad();
    });
  }

  // add(id: any,data: any):void{
  //      this.accountName = data['name'];
  //      this.replenishmentModal=true;
  //      this.accountIdForReplenishment =id;
  // }

  // onReplenishment(form: NgForm){
  //   this.payButtonVisible=true;
  //   form['value'].account_id=this.accountIdForReplenishment;
  //   this.accountService.createAccountTransaction(form['value']).subscribe(response=>{this.replenishmentModal=false;  this.payButtonVisible=false;this.onLoad();});
  //   console.log(form['value']);

  // }

  backClicked() {
    this.location.back();
}

}



// WEBPACK FOOTER //
// C:/Users/User/Documents/Projects/Ekopen/angular2-store-test/src/app/dashboard/pages/accounts/account/account.component.ts